import AMapMouseTool from './a-map-mouse-tool'

export default AMapMouseTool